import AdminBqTqFormsPanel from "../components/bq-tq-admin/AdminBqTqFormsPanel";

const AdminBqTqPage = () => <AdminBqTqFormsPanel />;

export default AdminBqTqPage;
